import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../assets/ChiroLogo.png";

const TabMenu = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const linkClass = ({ isActive }) =>
    `relative px-3 py-1.5 text-sm font-medium tracking-wide transition-colors duration-200 ${
      isActive ? "nav-active-line" : "text-white/55 hover:text-white/90"
    }`;

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? "bg-[#080808]/98 backdrop-blur-xl border-b border-white/[0.06] shadow-2xl"
            : "bg-[#080808]/85 backdrop-blur-md border-b border-white/[0.04]"
        }`}
        style={{ height: "6rem" }}
      >
        {/* Desktop: all links + logo tightly centered */}
        <div className="hidden sm:flex h-full items-center justify-center gap-10">
          <NavLink to="/" className={linkClass}>Home</NavLink>
          <NavLink to="/content" className={linkClass}>Content</NavLink>

          <NavLink to="/" className="mx-2 flex items-center">
            <img src={Logo} alt="Logo" className="h-20 w-auto" />
          </NavLink>

          <NavLink to="/contact" className={linkClass}>Contact</NavLink>
          <NavLink to="/reviews" className={linkClass}>Reviews</NavLink>
        </div>

        {/* Mobile: logo left, hamburger right */}
        <div className="sm:hidden h-full flex items-center justify-between px-5">
          <NavLink to="/">
            <img src={Logo} alt="Logo" className="h-14 w-auto" />
          </NavLink>
          <button
            onClick={() => setMenuOpen(true)}
            className="p-2 text-white/60 hover:text-white transition-colors"
            aria-label="Open menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
            </svg>
          </button>
        </div>
      </nav>

      {/* Mobile overlay menu */}
      {menuOpen && (
        <div className="fixed inset-0 z-[100] flex flex-col bg-[#080808] sm:hidden">
          <button
            onClick={() => setMenuOpen(false)}
            className="absolute top-6 right-6 p-2 text-white/50 hover:text-white transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          <div className="flex flex-col items-center justify-center flex-1 gap-10">
            <img src={Logo} alt="Logo" className="h-20 mb-4 opacity-90" />
            <div className="gold-divider w-32" />
            {[
              { to: "/", label: "Home" },
              { to: "/content", label: "Content" },
              { to: "/contact", label: "Contact" },
              { to: "/reviews", label: "Reviews" },
            ].map(({ to, label }) => (
              <NavLink
                key={to}
                to={to}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `text-2xl font-light tracking-widest transition-colors ${
                    isActive ? "text-[#d4aa45]" : "text-white/70 hover:text-white"
                  }`
                }
              >
                {label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default TabMenu;
